module.exports = __webpack_public_path__ + "media/images/clue-4120a5ee8d67acf611aaf910d4f37aba.png";